import React from 'react'
import {
    CellsTitle, Cells, TextArea, CellBody, Form, FormCell, Button,
    Toast, Toptips, Dialog
} from 'react-weui'
import axios from 'axios'
import qs from 'qs'
import { browserHistory } from 'react-router'
import Header from '../../components/liveroomLecturer/Header'
import '../../css/page/ChannelEditPage.css'


class ChannelEditTitlePage extends React.Component {
    constructor (props) {
        super(props)
        this.type = /^\/lecture\//.test(props.location.pathname) ? 'lecture' : 'channel'
        this.state = {
            file: '',
            cover: '',
            isPending: false,
            coverHeight: 200,
            alertDialog: {
                isShow: false,
                text: '',
            },
            tip: {
                isShow: false,
                text: '',
                type: 'warn',
            },
        }
    }
    componentDidMount () {
        this.fetchCover()
        this.handleCoverSize()
        window.addEventListener('resize', e => this.handleCoverSize())
    }
    handleCoverSize () {
        if (!this.$cover) {
            return
        }
        const rect = this.$cover.getBoundingClientRect()
        const coverHeight = 480 * (rect.width) / 840
        this.setState({ coverHeight })
    }
    fetchCover () {
        this.setState({ isPending: true })
        axios.get(`/api/${this.type}/${this.props.params.id}/edit_info`)
            .then(res => {
                this.setState({
                    cover: res.data.data[this.type].cover_url,
                    isPending: false,
                })
            })
    }
    onClickAlertOk () {
        if (/is_from_info/.test(location.search)) {
            location.assign(`/${this.type}2/${this.props.params.id}?_t=${Date.now()}`)
        } else {
            browserHistory.go(-1)
        }
    }
    bindValue (e, field) {
        this.setState({ [field]: e.target.value })
    }
    onChangeFile (e) {
        const file = e.target.files[0]
        if (!file) return
        const _this = this
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function(e) {
            _this.setState({ cover: this.result, file })
        }
    }
    showTip (text, type = 'warn') {
        this.setState({
            tip: { isShow: true, text, type },
        })
        setTimeout(() => {
            this.setState({
                tip: { isShow: false },
            })
        }, 2000)
    }
    onSubmit () {
        if (this.state.file) {
            const formData = new FormData()
            formData.append('cover', this.state.file)
            this.setState({ isPending: true })
            axios.post(`/api/${this.type}/${this.props.params.id}/edit`, formData)
                .then(res => {
                    this.setState({ isPending: false })
                    if (res.data.code !== 0) {
                        return this.showTip(res.data.msg)
                    }
                    this.showAlert('修改成功')
                })
        } else {
            this.$input.click()
        }
    }
    showAlert (text) {
        this.setState({
            alertDialog: { isShow: true, text }
        })
    }
    render() {
        return (
            <div className='page'>
                <div className="wk-inner-page channel-edit-page">
                    <div className="cover-page">
                        <Header title='当前封面图' />
                        <div
                            className="cover"
                            style={{
                                position: this.state.file ? 'relative' : 'static',
                                height: `${this.state.coverHeight}px`,
                                backgroundImage: `url(${this.state.cover})`,
                            }}
                            ref={r => this.$cover = r}
                        >
                            <input
                                ref={r => this.$input = r}
                                type="file"
                                onChange={e => this.onChangeFile(e)}
                            />
                        </div>
                        <p className="intro">请上传840*480尺寸</p>
                        <div className="wk-btn-90 padding-top-10 p-rlt">
                            <Button onClick={e => this.onSubmit()}>
                                {this.state.file ? '保存' : '更换封面图'}
                            </Button>
                        </div>
                    </div>
                </div>
                <Toast icon="loading" show={this.state.isPending}></Toast>
                <Toptips type={this.state.tip.type} show={this.state.tip.isShow}>{this.state.tip.text}</Toptips>
                <Dialog type="ios" title='' buttons={[
                    { label: 'Ok', onClick: () => this.onClickAlertOk() }
                ]} show={this.state.alertDialog.isShow}>
                    {this.state.alertDialog.text}
                </Dialog>
            </div>
        )
    }
}

export default ChannelEditTitlePage



// WEBPACK FOOTER //
// ./src/pages/ChannelEdit/ChannelEditCoverPage.js